// 个人信息管理
<template>
    <div class="group maininfo">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>{{ $t('common.Information') }}</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-form :inline="true" label-width="100px" size="medium" :model="userInfo" class="demo-form-inline" ref="userInfo">
                            <el-form-item prop="name" label="" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ $t('common.hello') }} {{ userInfo.name }}, {{ $t('common.welcome') }}</span>
                            </el-form-item><br>
                            <el-form-item prop="realname" :label="$t('common.RealName') + ':'" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.realname }}</span>
                            </el-form-item>
                            <el-form-item prop="type" label="Type：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.type }}</span>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="count" :label="$t('common.LoginTimes') + ':'" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.count }}</span>
                            </el-form-item><br>
                            -->
                            <!--
                            <el-form-item prop="type" label="用户身份：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.type }}</span>
                            </el-form-item><br>
                            -->
                            <el-form-item prop="createtime" :label="$t('common.JoinTime') + ':'" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.createtime }}</span>
                            </el-form-item><br>
                            
                            <el-form-item prop="op_time" :label="$t('common.LastLogin') + ':'" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.op_time }}</span>&nbsp;&nbsp;&nbsp;
                                <!--<span>{{ userInfo.loginip }}</span>-->
                            </el-form-item><br>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    const Base64 = require('js-base64').Base64;
    export default {
        data() {
            return {
                // 查询
                query: {
                    clzt: '',
                    khmc: '',
                    data_dt: []
                },
                // 用户信息
                userInfo: {
                    name: '',
                    type: '',
                    role: '',
                    dept: '',
                    count: '',
                    realname: '',
                    createtime: '',
                    op_time: '',
                    loginip: '',
                },
                // 分页
                pager: {
                    page: 1,
                    rows: 10,
                    total: 0
                }
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                //this.getUserInfoAllList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                //this.getUserInfoAllList();
            },
            // 获取个人信息列表
            getUserInfoByCondition() {
                let _this = this;
                util.publicget('/user/getUserInfoByCondition2', {
                    username: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        _this.userInfo.name = res.userName;
                        _this.userInfo.realname = res.realname;
                        if(res.userType === 0){
                            _this.userInfo.type = 'employee';
                        }else if(res.userType === 1 || res.userType === 2){
                            _this.userInfo.type = 'manager';
                        }else if(res.userType === 3){
                            _this.userInfo.type = 'super_manager';
                        }else if(res.userType === 4){
                            _this.userInfo.type = 'vip_customer';
                        }
                        _this.userInfo.createtime = res.createtime;
                        _this.userInfo.count = res.countTotal;
                        _this.userInfo.op_time = res.op_time;
                        _this.userInfo.loginip = res.loginip;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 时间确定按钮
            onChangeDate(val) {
                if (val) {
                    let that = this;
                    that.query.data_dt = [this.getControlTimeTo(val[0]), this.getControlTimeTo(val[1])];
                }
            }
        },
        mounted() {
            this.getUserInfoByCondition();
        }
    };
</script>

<style lang="scss">
/**手机屏幕展示 */
    @media screen and (max-width: 748px){
        .mainds {
            position: relative;
            float: left;
            height: 500px;
        }
        .mainds {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.71);
            transform: scale(0.71);
            transform-origin: left top;
        }
        /**奇偶行变色 */
        .el-table__row--striped td {
            background-color: #eaf3fb !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/pzxx/personalInfo.vue